<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  v-model="searchType"
                  default-value="name"
                  @change="searchTypeOnChange"
                  style="width: 80px"
                >
                  <a-select-option value="name"> Name </a-select-option>
                  <a-select-option value="code"> Code </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                v-model="table.filters.status"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null"> All </a-radio>
                <a-radio :style="radio.style" value="A"> Active </a-radio>
                <a-radio :style="radio.style" value="I"> Inactive </a-radio>
              </a-radio-group>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <template #headerButtons>
            <base-button
              id="new"
              v-if="selectedActions.includes('Add')"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Add Payment Type</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <PaymentTypeForm
                :viewMode="viewMode"
                :paymentTypeData="paymentTypeData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <div class="d-flex justify-content-around">
              <button
                id="view"
                v-if="selectedActions.includes('View')"
                class="btn btn-success btn-sm w-100"
                @click.prevent="openDrawer(tableProps.rowData)"
              >
                View
              </button>
              <button
                id="edit"
                v-if="selectedActions.includes('Edit')"
                class="btn btn-warning btn-sm w-100"
                @click.prevent="openDrawer(tableProps.rowData)"
              >
                Edit
              </button>
              <a-popconfirm
                title="You are about to delete this record?"
                v-if="!['POINTS', 'CASH'].includes(tableProps.rowData.code)"
                @confirm="deleteRow(tableProps.rowData)"
                okText="Delete"
                cancelText="Cancel"
              >
                <a class="btn btn-danger btn-sm text-white w-100">Delete</a>
              </a-popconfirm>
            </div>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import PaymentTypeForm from './PaymentTypeForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    PaymentTypeForm
  },
  data() {
    return {
      gradientType: 'gradient-teal',
      search: null,
      paymentTypeData: null,
      searchType: 'name',
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Payment Types',
        apiUrl: '/api/v1/payment_types',
        fields: [
          'actions',
          { name: 'name', title: 'Name' },
          { name: 'code', title: 'Code' },
          { name: 'status', title: 'Status' },
          {
            name: 'extras',
            title: 'Require Remarks',
            formatter(extras) {
              const jsonData = extras ? JSON.parse(extras) : null;
              return jsonData && jsonData.hasRemarks ? 'True' : 'False';
            }
          }
        ],
        filters: {
          status_code: null,
          name: null,
          code: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.paymentTypeData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.paymentTypeData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    searchTypeOnChange() {
      this.table.filters = {
        name: null,
        card: null
      };
      this.table.filters[this.searchType] = this.search;
    },
    async deleteRow(rowData) {
      const paymentTypeId = rowData.id;
      const requestBody = {
        card_type: { membership_program_id: rowData.membership_program_id }
      };
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/payment_types/${paymentTypeId}`,
        requestBody
      );

      if (response.id) {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  watch: {
    search(val) {
      this.table.filters[this.searchType] = val;
    }
  },
  created() {
    this.$store.dispatch('setCurrentModule', 'PaymentType');
  }
};
</script>

<style scoped></style>
